import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuthorization from '../../hooks/useAuthorization';
import { RESOURCE_TYPE } from '../../HelperMethods/role-resource-constants';

const AuthRoute = React.memo(function AuthRoute({ view, redirectUrl, children, viewsHolder, ...props }) {
  const history = useHistory();
  const { pathname } = window.location;
  const authorizationResult = useAuthorization({
    resourceType: RESOURCE_TYPE.VIEW,
    resource: view,
  });
  const isAuthorized = viewsHolder ? true : authorizationResult;

  if (pathname !== localStorage.getItem('pathname')) {
    const path = pathname.startsWith('/joynfsm') ? window.location.pathname.substring(8) : pathname;
    localStorage.setItem('pathname', path);
  }

  useEffect(() => {
    return history.listen((location) => {
      // eslint-disable-next-line no-underscore-dangle
      window._mfq.push(['newPageView', location.pathname]);
    });
  }, [history]);

  const childrenComponent = (routeProps) =>
    isAuthorized ? (
      children(routeProps)
    ) : (
      <Redirect to={{ pathname: redirectUrl, state: { from: routeProps.location } }} />
    );
  return <Route {...props} children={childrenComponent} />;
});

export default AuthRoute;

AuthRoute.propTypes = {
  view: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  redirectUrl: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  viewsHolder: PropTypes.any,
};
